module.exports = __webpack_public_path__ + "img/link.8a34b88d.svg";